document.addEventListener('scroll', function() {
    const titleElements = document.querySelectorAll('.section-heading-decorator');
    
    titleElements.forEach(titleElement => {
        const rect = titleElement.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        let progress;

        if (window.innerWidth > 992) {
          progress = Math.min(Math.max(0.1, ((windowHeight - rect.top) - 130) / (windowHeight * 0.5)), 1);
        } else {
          progress = Math.min(Math.max(0.1, ((windowHeight - rect.top) - 130) / (windowHeight * 0.5)), 1);
        }

        const title = titleElement.querySelector('span');
        if(title != null) {
            title.style.transform = `scale(${progress})`;
            title.style.opacity = progress;
            const fullHeight = title.scrollHeight;
    
            title.style.height = `${progress * fullHeight}px`;
                
            if(window.innerWidth > 992) {
              titleElement.style.setProperty('--before-margin', `${progress * 18}px`); 
              titleElement.style.setProperty('--after-margin', `${progress * 18}px`);
            } else {
              titleElement.style.setProperty('--before-margin', `${progress * 10}px`); 
              titleElement.style.setProperty('--after-margin', `${progress * 10}px`);
            }
        }
    });
});